// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_vue-video-player@5.0.2@vue-video-player/src/custom-theme.css
// module id = 684
// module chunks = 5